import type {
  PropertySelectionRow,
  RequestedPicturesPlotDataResponse,
} from "../../types";

/**
 * 既存の行を検索する
 * @param properties プロパティ配列
 * @param plot 検索対象のプロットデータ
 * @returns 見つかった行またはundefined
 */
export const findExistingRow = (
  properties: PropertySelectionRow[],
  plot: RequestedPicturesPlotDataResponse
): PropertySelectionRow | undefined => {
  return properties.find(
    (row) =>
      row.location === plot.location &&
      row.chibanKaokuNumber === plot.chiban &&
      row.prefName === plot.prefectureName
  );
};
